function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_recycle_bin"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21.707 20.293-18-18c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.362 1.362c-.381.142-.655.5-.655.931 0 .553.447 1 1 1h1v12c0 1.654 1.346 3 3 3h8c1.237 0 2.302-.754 2.76-1.826l1.533 1.533c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm-4.707-1.293c0 .552-.448 1-1 1h-8c-.552 0-1-.448-1-1v-10.586l2 2v6.586c0 .553.447 1 1 1s1-.447 1-1v-4.586l2 2v2.586c0 .553.447 1 1 1s1-.447 1-1v-.586l2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.293 6.707c.187.188.441.293.707.293h6v6c0 .553.447 1 1 1s1-.447 1-1v-6h1c.553 0 1-.447 1-1s-.447-1-1-1h-5c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 .266.105.52.293.707zm1.707-2.707c.552 0 1 .448 1 1h-1.586l-.351-.351c.143-.378.509-.649.937-.649z"
})));

var Svg080Recyclebin = function Svg080Recyclebin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg080Recyclebin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/080-recycle bin.6cf4a7fe.svg";
export { ForwardRef as ReactComponent };